var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"button",class:[_vm.type],on:{"click":_vm.didClick}},[_c('span',{staticClass:"button-icon",class:[_vm.icon]}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }